import baseAPI from '@/http'

const router = 'api/municipio'

export const cityAPI = {
  create: (city) => baseAPI.post(router, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getMunicipioTema: (temaId) => baseAPI.get(`${router}/get-municipios-tema?temaId=${temaId}`),
  listNames: () => baseAPI.get(router + '/get-nomes'),
  getTasksReport: (id) => baseAPI.get(`${router}/relatorio-tarefa/${id}`),
  updateImageMunicipio: (val) => baseAPI.put(`${router}/update-imagem`, val),
  getRadar: () => baseAPI.get(`${router}/get-radar`)
}
